"use strict";

exports.__esModule = true;
exports.MetricChartFields = MetricChartFields;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Translator = require("../../Core/Translator");
var _MetricChartSeriesControls = require("../../Metrics/MetricChartSeriesControls");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AxisControls = _styledComponents["default"].div.withConfig({
  displayName: "MetricChartFields__AxisControls",
  componentId: "sc-26ovjr-0"
})(["display:flex;label{flex:1;}"]);

/**
 * Fields for MetricChartElement.
 */
function MetricChartFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("MetricChartFields.metricChartSeries.label", "Chart Series")
    }, /*#__PURE__*/_react["default"].createElement(_MetricChartSeriesControls.MetricChartSeriesControls, {
      value: element.props.metricChartSeries,
      onChange: function onChange(metricChartSeries) {
        return elementEditor.setProp(path, "metricChartSeries", metricChartSeries);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("MetricChartFields.axes.label", "Axes")
    }, /*#__PURE__*/_react["default"].createElement(AxisControls, null, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "hideXAxis"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      id: "hideXAxis",
      type: "checkbox",
      checked: element.props.hideXAxis || false,
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "hideXAxis", e.target.checked);
      }
    }), " ", translate("MetricChartFields.axes.hideXAxis, label", "Hide X Axis")), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "hideYAxis"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      id: "hideYAxis",
      type: "checkbox",
      checked: element.props.hideYAxis || false,
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "hideYAxis", e.target.checked);
      }
    }), " ", translate("MetricChartFields.axes.hideYAxis.label", "Hide Y Axis")), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "hideLabel"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      id: "hideLabel",
      type: "checkbox",
      checked: element.props.hideLabel || false,
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "hideLabel", e.target.checked);
      }
    }), " ", translate("MetricChartFields.axes.hideUnits.label", "Hide Units")))), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Consumer, null, function (layoutSettings) {
      return layoutSettings.selection.allowReportingPeriod && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("MetricChartFields.dataRange.label", "Data Range"),
        helperText: translate("MetricChartFields.dataRange.helperText", "The data range to show in this chart.")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.HTML_SELECT
      }, /*#__PURE__*/_react["default"].createElement("select", {
        value: element.props.dataRange || "",
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "dataRange", e.target.value || undefined);
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, translate("MetricChartFields.dataRange.reportingPeriod.label", "Reporting Period")), /*#__PURE__*/_react["default"].createElement("option", {
        value: "SELECTION"
      }, translate("MetricChartFields.dataRange.selection.label", "Selection")))));
    }));
  });
}